import { AuthErrorCode } from '../constants';
import { DomainErrorName } from '../constants';

/** The auth service catches these and maps to typed AuthResult outcomes. */

/** Cognito account exists but email unverified. Auth service returns `{ ok: AuthOutcome.RequiresEmailVerification }`. */
export class UserNotConfirmedError extends Error {
  readonly email: string;
  constructor(email: string) {
    super(`Email verification required for ${email}`);
    this.name = DomainErrorName.UserNotConfirmed;
    this.email = email;
  }
}

/** Cognito forced reset for migrated users. Auth service maps to `{ ok: AuthOutcome.RequiresPasswordReset }`. */
export class PasswordResetRequiredError extends Error {
  readonly email: string;
  constructor(email: string) {
    super(`Password reset required for ${email}`);
    this.name = DomainErrorName.PasswordResetRequired;
    this.email = email;
  }
}

/**
 * Apple Sign In: the user's Apple ID token email is a private relay address but the
 * account on record uses their real email — the two cannot be linked.
 */
export class PrivateEmailExposedError extends Error {
  constructor() {
    super('Apple Hide My Email cannot be used with an existing account');
    this.name = DomainErrorName.PrivateEmailExposed;
  }
}

export { AuthErrorCode };
